export default __webpack_public_path__ + "static/media/BCSuperDry.b3ce9c03.webp";